<div
  class="grid items-center grid-cols-5 gap-4 p-4 cursor-pointer bg-red-4 text-grey-1 max-sm:py-3 max-sm:px-2 rounded-5 max-sm:mt-2"
  (click)="$event.stopPropagation(); toogleExpanded()"
>
  <div class="flex items-center col-span-3 gap-4 max-sm:gap-1">
    <img
      class="w-[40px] h-[40px] max-sm:w-[20px] max-sm:h-[20px] cursor-pointer border border-grey-7 border-solid rounded-full object-contain"
      alt="logo"
      (error)="onImgError($event)"
      [src]="getCountryImg()"
    />
    <a
      class="cursor-pointer font-roboto-600 text-18 max-sm:text-11 hover:underline"
      [routerLink]="[getUrlEntity()]"
    >
      {{ data().CountryName && getTraduccionCountryName() + " -" }}
      <span class="font-roboto-400">
        {{ getTraduccionName() }}
      </span>
    </a>
  </div>

  <div class="flex justify-end col-span-2 gap-4 max-sm:gap-2">
    <img
      alt="logo"
      [src]="getImgFavorite()"
      class="max-sm:w-[16px] cursor-pointer"
      (click)="$event.stopPropagation(); toogleEntityFavorite()"
    />
    <div
      class="text-nowrap justify-center px-3 py-1 max-sm:px-2 bg-white font-roboto-400 max-sm:text-10 rounded-[100px]"
    >
      {{ "Matches" | translate }} ({{ data().Matches.length }})
    </div>
    <img
      (click)="$event.stopPropagation(); toogleExpanded()"
      alt="logo"
      [src]="arrowIcon"
      class="cursor-pointer max-sm:w-[7px] transition-all duration-300 ease-in-out"
      [class.rotate-180]="expandedItems()"
    />
  </div>
</div>

@if(expandedItems() && data().Matches.length > 0){
<div class="flex flex-col gap-4 mt-3 max-sm:gap-2">
  @for (match of data().Matches; track match.Id) {

  <app-match-by-team-item [data]="match" />
  }
</div>
}
